export default __webpack_public_path__ + "components/weather-icon/static/daymodsnow-60d00627b57892f27956645644d5f5e2.png";